<template>
  <div class="optional-module">
    <div class="title">{{ title }}</div>
    <div class="optional-item" v-for="(item, index) in giftsList" :key="index">
      <v-checkbox
        class="v-checkbox"
        :value="item.canOptional == 1"
        :aria-label="item.canOptional == 1?'已选中，点击取消选择':'未选中，点击选择'"
        @click.native="handleSelect(item)"
        v-track="{
          act: 'click',
          params: {
            cfrom: '160|004|01|077',
            event_id: '160|004|01|077',
            page_name: 1,
            sku_id: (item.optionalGiftId||'') + item.id,
            gift_type: item.giftFlag,
            gift_content: contentChange(item),
            position: index + 1,
            isno_choose: 1
          }
        }"
      ></v-checkbox>
      <giveaway-pop-item
        :giftItem="item"
        :positionKey="index"
        isOptional
        @select="handleSelect(item)"
      ></giveaway-pop-item>
    </div>
  </div>
</template>

<script>
import GiveawayPopItem from '../giveaway-pop-item'
import { giftContentChange } from '@/components/gift-popup/trackData'

export default {
  name: 'OptionalGifts',
  components: {
    GiveawayPopItem
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    optionalGiftId: [Number, String],
    selectNums: Number,
    skuId: [Number, String]
  },
  computed: {
    title() {
      return `以下赠品${this.giftsList.length}选${this.selectNums}，已选${this.selectedList.length}件`
    }
  },
  watch: {
    list: {
      handler(newVal) {
        this.giftsList = JSON.parse(JSON.stringify(newVal)) 
        this.selectedList = this.giftsList.filter(item => item.canOptional)
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      selectedList: [],
      giftsList: [],
      contentChange: giftContentChange
    }
  },
  mounted() {
    //
  },
  methods: {
    handleSelect(item) {
      if (this.selectNums == 1) {
        if (this.selectedList.includes(item)) {
          this.selectedList.splice(0, 1)[0].canOptional = 0
        } else {
          let obj = this.selectedList.splice(0, 1, item)[0]
          if (obj) obj.canOptional = 0
          item.canOptional = 1
        }
      } else if (this.selectedList.length == this.selectNums && !this.selectedList.includes(item)) {
        this.$toast(`最多选择${this.selectNums}件，可取消已选赠品后再选择`)
        this.$track({
          cfrom: '159|003|02|077',
          event_id: '159|003|02|077',
          page_name: 1
        })
      } else if (this.selectedList.includes(item)) {
        this.selectedList.splice(this.selectedList.indexOf(item), 1)[0].canOptional = 0
      } else {
        this.selectedList.push(item)
        item.canOptional = 1
      }
      this.$emit(
        'select',
        this.optionalGiftId,
        this.selectedList.map(v => v.id)
      )
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
